import { SUPPLIERS_BY_TAG, getSupplierFromGameTags } from 'src/containers/JackpotsFromProviders'
import { useAppSelector } from 'store/hooks'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'
import { getProvidersJackpotAmountSelector } from 'store/modules/jackpotsFromProviders/selectors'

export type JackpotTickerData = {
  amount: number
  currency: 'GC' | 'SC'
}

export type GameWithTagsAndSupplier = {
  code?: string
  tags?: unknown[]
  supplier?: string
}

export function useJackpotTickerData(game: GameWithTagsAndSupplier | null | undefined): JackpotTickerData | null {
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)
  const supplier = getSupplierFromGameTags((game?.tags ?? []) as string[], SUPPLIERS_BY_TAG)
  const currency = activeCurrency === 'SC' ? 'SC' : 'GC'

  const amount = useAppSelector((state) => getProvidersJackpotAmountSelector(state, { supplier, currency }))

  if (!amount) {
    return null
  }

  return { amount, currency }
}

export function useHasJackpotTicker(game: GameWithTagsAndSupplier | null | undefined): boolean {
  return useJackpotTickerData(game) !== null
}
